import React from 'react'
import NextLink from 'next/link'
import {
  Box,
  Flex,
  FlexProps,
  Image,
  Link,
  LinkBox,
  Text,
  VStack,
} from '@chakra-ui/react'

import { IPost } from '@/types/ghostData.interface'

interface Props extends FlexProps {
  post: IPost
}

export const FeaturedPost = ({ post, ...rest }: Props) => {
  return (
    <Flex
      w="full"
      flexDirection={{ base: 'column', lg: 'row' }}
      alignItems={{ base: 'flex-start', lg: 'center' }}
      background="gray.940"
      rounded="xl"
      overflow="hidden"
      color="white"
      {...rest}
    >
      <Box order={{ base: 1, lg: 0 }} p={8}>
        <VStack gap={6} alignItems="flex-start">
          <Text color="whiteAlpha.500" lineHeight="normal">
            Featured Article
          </Text>
          <Box>
            <Text
              variant="spaceGrotesk"
              mb={2.5}
              fontSize="2xl"
              lineHeight="normal"
            >
              {post.title}
            </Text>
            <Text lineHeight="normal">{post.excerpt}</Text>
          </Box>
          <NextLink href={`/education/${post.slug}`} passHref>
            <Link>Read Article →</Link>
          </NextLink>
        </VStack>
      </Box>
      {post.feature_image && (
        <NextLink href={`/education/${post.slug}`} passHref>
          <LinkBox
            w={{ base: '100%', lg: '70%' }}
            cursor="pointer"
            order={{ base: 0, lg: 1 }}
            flexShrink={0}
          >
            <Image
              src={post.feature_image}
              alt={post.title}
              objectFit="cover"
              objectPosition="top right"
            />
          </LinkBox>
        </NextLink>
      )}
    </Flex>
  )
}
